import has from 'mout/object/has'
import forOwn from 'mout/object/forOwn'

import { db } from '../../config/firebaseconfig'


export default function initializeManageEducators(user, actions, matchParams) { 
  if (has(user, 'role')) {
    if (user.role === 'Super Administrator') {
      //Get all districts, schools, educators, students, and classes
      actions.initializing()

      const dataToGet = ['districts', 'schools', 'educators', 'students', 'classes']
      let promises = []
      dataToGet.forEach((dataType) => {
        let call = db.collection(dataType).onSnapshot((querySnapshot) => {
          let dataToAdd = {}
          querySnapshot.forEach((doc) => {
            const data = doc.data()
            if (data.id && !data.deleted) {
              dataToAdd[data.id] = data
            }
          })
          actions.set[dataType](dataToAdd)
        })
        promises.push(call)
      })

      Promise.all(promises)
        .then(() => actions.initializingSuccess())
        .catch((err) => actions.initializingError(err))
    } else if (user.role === 'District Admin' || user.role === 'School Admin' || user.role === 'Teacher') {
      actions.initializing()
      let dataToGet = ['schools', 'educators', 'students', 'classes']
      if (user.role === 'School Admin') {
        dataToGet = ['educators', 'students', 'classes']
      } else if (user.role === 'Teacher') {
        dataToGet = ['students', 'classes']
      }
      let promises = []
      dataToGet.forEach((dataType) => {
        let call, searchTerm, searchVal
        if (user.role === 'District Admin' /*|| user.role === 'School Admin'*/) {
          searchTerm = 'district'
          if (dataType === 'students' || dataType === 'educators') {
            searchTerm = 'schoolDistrict'
          }
          searchVal = user.schoolDistrict
        } else if (user.role === 'Teacher' || user.role === 'School Admin') {
          searchTerm = 'school'
          searchVal = user.school
        }
        call = db.collection(dataType).where(searchTerm, '==', searchVal)
          .onSnapshot((querySnapshot) => {
            let dataToAdd = {}
            querySnapshot.forEach((doc) => {
              const data = doc.data()
              if (data.id && !data.deleted) {
                dataToAdd[data.id] = data
              }
            })
            actions.set[dataType](dataToAdd)
          })
          promises.push(call)
      })
      const districtCall = db.collection('districts').doc(user.schoolDistrict)
        .onSnapshot((doc) => {
          let dataToAdd = {}
          const data = doc.data()
          if (data && data.id && !data.deleted) {
            dataToAdd[data.id] = data
          }
          actions.set.districts(dataToAdd)
        })
      promises.push(districtCall)
      if (user.role === 'School Admin' || user.role === 'Teacher') {
        const schoolCall = db.collection('schools').doc(user.school)
          .onSnapshot((doc) => {
            let dataToAdd = {}
            const data = doc.data()
            if (data.id && !data.deleted) {
              dataToAdd[data.id] = data
            }
            actions.set.schools(dataToAdd)
          })
        promises.push(schoolCall)
      }
      if (user.role === 'Teacher') {
        const teacherCall = db.collection('educators').doc(user.id)
          .onSnapshot((doc) => {
            let dataToAdd = {}
            const data = doc.data()
            if (data.id && !data.deleted) {
              dataToAdd[data.id] = data
            }
            actions.set.educators(dataToAdd)
          })
        promises.push(teacherCall)
      }

      Promise.all(promises)
        .then(() => actions.initializingSuccess())
        .catch((err) => actions.initializingError(err))
    }
  }

}



// WEBPACK FOOTER //
// ./src/helpers/users/initializeManageEducators.js